"use strict";
exports.__esModule = true;
exports.accounts$ = exports.selectAccounts$ = void 0;
var rxjs_1 = require("rxjs");
exports.selectAccounts$ = new rxjs_1.BehaviorSubject({ inProgress: false, actionRequired: '' });
exports.accounts$ = new rxjs_1.Subject();
